/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "MapToPlanTokensRequest": {
                "fields": {
                  "externalCardTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MapToPlanTokensResponse": {
                "fields": {
                  "externalCardTokenToPlanTokens": {
                    "type": "string",
                    "id": 1,
                    "keyType": "string"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.MapToPlanTokensRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.MapToPlanTokensResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE MapToPlanTokensRequest @ squareup/corporate_card/service/map_to_plan_tokens.proto at 8:1
 */
export const MapToPlanTokensRequest = $root.lookupType('squareup.corporate_card.service.MapToPlanTokensRequest');
fixType(MapToPlanTokensRequest);
Builder.createAndAttachToType(MapToPlanTokensRequest);
/**
 * SOURCE MapToPlanTokensResponse @ squareup/corporate_card/service/map_to_plan_tokens.proto at 15:1
 */
export const MapToPlanTokensResponse = $root.lookupType('squareup.corporate_card.service.MapToPlanTokensResponse');
fixType(MapToPlanTokensResponse);
Builder.createAndAttachToType(MapToPlanTokensResponse);